<template>
    <div class="row m-0" style="height: 100%">
        <div class="col-7 chart-area">
            <!-- <span class="section-title">{{ "[데이터 트렌드]" }}</span> -->
            <TrendChart
                v-if="events"
                :chartData="totalLog"
                :pointInfo="pointInfo"
                :abnormalData="events.abnormalEvents"
                :abnormalDefs="events.abnormalDefs"
                :missingData="events.missingStatus"
                :useType="'correction'"
                :eventDetail="eventDetail"
                @showModal="showDetectParamModal"
            />
        </div>
        <div class="col-5 table-area">
            <div class="table-wrapper">
                <!-- 탭 헤더 -->
                <div v-if="events" class="tab-header">
                    <div class="tab-tabs">
                        <div
                            class="tab-item"
                            :class="{ active: activeTab === 'abnormal' }"
                            @click="activeTab = 'abnormal'"
                        >
                            <span class="tab-title">이상치 구간</span>
                        </div>
                        <div
                            class="tab-item"
                            :class="{ active: activeTab === 'missing' }"
                            @click="activeTab = 'missing'"
                        >
                            <span class="tab-title">결측치 구간</span>
                        </div>
                    </div>
                    <div class="tab-actions">
                        <div class="dataDownloadIcon" @click="animate($event, activeTab)">
                            <i ref="forwardIcon" class="material-icons forwardIcon"> forward </i>
                            <i class="material-icons removeIcon"> remove </i>
                        </div>
                    </div>
                </div>

                <!-- 탭 컨텐츠 -->
                <div v-if="events" class="tab-content">
                    <!-- 이상치 구간 탭 -->
                    <div v-show="activeTab === 'abnormal'" class="tab-panel">
                        <AbnormalEventTable
                            :abnormalData="events"
                            :unit="unit"
                            :eventDetail="eventDetail"
                            :flagAbnormalDownload="flagAbnormalDownload"
                            :totalLog="totalLog"
                            @showModal="showDetectParamModal"
                            @update:flagAbnormalDownload="setExcelFlag('flagAbnormalDownload', false)"
                        />
                    </div>

                    <!-- 결측치 구간 탭 -->
                    <div v-show="activeTab === 'missing'" class="tab-panel">
                        <MissingEventTable
                            :tableData="events.missingStatus"
                            :flagMissingDownload="flagMissingDownload"
                            @update:flagMissingDownload="setExcelFlag('flagMissingDownload', false)"
                        />
                    </div>
                </div>
            </div>
        </div>
        <DetectParamModal ref="DetectParamModal" :detectParam="detectParam" />
    </div>
</template>

<script>
import moment from "moment";
import TrendChart from "../chart/TotalLogChart.vue";
import AbnormalEventTable from "../table/AbnormalEventTable.vue";
import MissingEventTable from "../table/MissingEventTable.vue";
import DetectParamModal from "../modal/DetectParamModal.vue";

export default {
    props: {
        totalLog: { type: Array, default: () => [] },
        pointInfo: { type: Object, default: () => {} },
        events: { type: Object, default: () => {} },
        unit: { type: String, default: "" },
        eventDetail: { type: Object, default: () => {} },
    },
    data() {
        return {
            flagAbnormalDownload: false,
            flagMissingDownload: false,
            detectParam: null,
            activeTab: "abnormal", // 활성화된 탭 상태
        };
    },
    components: {
        TrendChart,
        AbnormalEventTable,
        MissingEventTable,
        DetectParamModal,
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    methods: {
        setExcelFlag(flagName, value) {
            this[flagName] = value;
        },
        animate(event, type) {
            if (type === "abnormal") {
                // this.flagAbnormalDownload = true;
                this.setExcelFlag("flagAbnormalDownload", true);
            } else if (type === "missing") {
                this.setExcelFlag("flagMissingDownload", true);
                // this.flagMissingDownload = true;
            }
            const icon = event.currentTarget.querySelector(".forwardIcon");
            if (!icon) return;

            icon.classList.add("shake");

            setTimeout(() => {
                icon.classList.remove("shake");
            }, 600);
        },
        async showDetectParamModal(regDt) {
            const eventTime = moment(regDt.toString(), "YYYYMMDDHHmmss");

            const found = this.events.abnormalDefs.find((def) => {
                const start = moment(def.startDt.toString(), "YYYYMMDDHHmmss");
                const end = moment(def.endDt.toString(), "YYYYMMDDHHmmss");
                return eventTime.isBetween(start, end, null, "[]");
            });

            if (!this.isEmpty(found)) {
                this.detectParam = JSON.parse(found.detectParam);
                await this.$refs.DetectParamModal.show();
            } else {
                console.log("일치 구간 없음");
                return;
            }
        },
    },
};
</script>

<style scoped>
.chart-area {
    height: 100%;
    /* margin-top: 10px; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.section-title {
    font-size: 13px;
    font-weight: 600;
    /* margin-bottom: 5px; */
}
.table-area {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-top: 20px;
}

.table-wrapper {
    display: flex;
    flex-direction: column;
    flex: 1;
    /* overflow-y: auto; */
    overflow: hidden;
}

/* 탭 스타일 */
.tab-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* border-bottom: 2px solid #3c5b6f; */
    /* background-color: #f8f9fa; */
    padding-right: 10px;
}

.tab-tabs {
    display: flex;
}

.tab-item {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 16px;
    cursor: pointer;
    background-color: #ececec;
    transition: all 0.3s ease;
    min-width: 150px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    margin-right: 2px;
    border-top: 1px solid #d5dbe0;
    border-right: 1px solid #d5dbe0;
    border-left: 1px solid #d5dbe0;
}

.tab-item:last-child {
    border-right: none;
}

.tab-item.active {
    background-color: #3c5b6f;
    color: white;
}

.tab-item:hover:not(.active) {
    background-color: #dee2e6;
}

.tab-title {
    font-size: 13px;
    font-weight: 600;
}

.tab-actions {
    display: flex;
    align-items: center;
}

.tab-content {
    flex: 1;
    overflow: hidden;
}

.tab-panel {
    height: 100%;
    overflow-y: auto;
}
.tableTitleSpan {
    background-color: #3c5b6f;
    color: white;
    border-radius: 6px 6px 0 0;
    display: flex;
    align-items: center;
    padding: 2px 80px;
}
.tableTitle {
    display: flex;
    justify-content: space-between;
    /* border-bottom: 1px solid #3c5b6f; */
}
.forwardIcon {
    transform: rotate(90deg);
}
.dataDownloadIcon {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    margin: 0 8px 0 1px;
}

.dataDownloadIcon .material-icons {
    font-size: 21px;
    margin: -4px 0;
    user-select: none;
}
@keyframes upDownShake {
    0% {
        transform: rotate(90deg) translateX(0);
    }
    20% {
        transform: rotate(90deg) translateX(-3px);
    }
    40% {
        transform: rotate(90deg) translateX(3px);
    }
    60% {
        transform: rotate(90deg) translateX(-3px);
    }
    80% {
        transform: rotate(90deg) translateX(3px);
    }
    100% {
        transform: rotate(90deg) translateX(0);
    }
}

.shake {
    animation: upDownShake 0.6s ease-in-out;
}
</style>
